export const ROLE_SUPER_ADMIN = "super_admin";
export const ROLE_TENANT_ADMIN = "tenant_admin";
export const ROLE_LEARNER = "learner";

export const QUESTION_TYPES = [
  { value: "true_false", label: "True / False" },
  { value: "multiple_choice", label: "Multiple Choice" },
  { value: "fill_in_blank", label: "Fill in the Blank" },
  { value: "word_guess", label: "Word Guess (Wordle)" },
  { value: "matching", label: "Matching Pairs" },
  { value: "ordering", label: "Ordering / Sequence" },
];

export const RESOURCE_TYPES = [
  { value: "ebook", label: "eBook" },
  { value: "guideline", label: "Guideline Document" },
  { value: "policy", label: "Policy Document" },
  { value: "webinar", label: "Recorded Webinar" },
  { value: "other", label: "Other" },
];

export const LESSON_TYPES = [
  { value: "hero", label: "Title / Hero slide" },
  { value: "video", label: "Video" },
  { value: "text", label: "Text" },
  { value: "term_explorer", label: "Term Explorer (click terms)" },
  { value: "slide", label: "Embedded Slides" },
  { value: "embed", label: "Embed (Slides / PPT / URL)" },
  { value: "pdf", label: "PDF document" },
  { value: "question", label: "Question (tap-to-reveal or pre-test)" },
];

export const FEEDBACK_TYPES = [
  { value: "issue", label: "Flag an Issue" },
  { value: "reconsider", label: "Suggest Reconsideration" },
  { value: "general", label: "General Feedback" },
];

export const CSRF_COOKIE_NAME = "csrf_token";
